import styled, { keyframes } from 'styled-components';
import { Icon } from '../icon';
import { basicButtonStyling, sizeDependantStyling, variantStyling } from '../button/buttonStyling';
import { ButtonColors } from '../button/ButtonVariant';
import { ButtonSizes } from '../button/ButtonSize';

export const DropdownRoot = styled.div`
    position: relative;
    display: inline-flex;
    align-self: flex-start;
`;

// The outline Button at compact size, built from the Button's own styling so it cannot drift from
// the header actions it sits beside. Open is the Button's `active` state.
export const DropdownTrigger = styled.button<{ $isOpen: boolean }>`
    display: flex;
    ${basicButtonStyling}
    ${sizeDependantStyling(ButtonSizes.compact, true, true, 'left')}
    ${p => variantStyling(ButtonColors.outline, false, p.$isOpen)}
    cursor: pointer;
`;

export const TriggerSparklesIcon = styled(Icon)`
    flex-shrink: 0;
`;

export const DropdownOverlay = styled.div<{ $width: string | number; $isOpen: boolean }>`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 1000;
    width: ${p => typeof p.$width === 'number' ? `${p.$width}px` : p.$width};
    border-radius: 4px;
    // No overflow: hidden — the card clips itself, and clipping here cut off its raised shadow.
    opacity: ${p => p.$isOpen ? 1 : 0};
    transform: ${p => p.$isOpen ? 'translateY(0)' : 'translateY(-6px)'};
    pointer-events: ${p => p.$isOpen ? 'auto' : 'none'};
    visibility: ${p => p.$isOpen ? 'visible' : 'hidden'};
    // Visible at once on open so the input can take focus; hidden only once the fade-out ends.
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s ${p => p.$isOpen ? '0s' : '0.2s'};
`;

// ─── Badge ────────────────────────────────────────────────────────────────────

const dotPulse = keyframes`
    0%, 100% { opacity: 0.3; transform: scale(0.8); }
    50% { opacity: 1; transform: scale(1); }
`;

export const BadgeWrapper = styled.div`
    position: absolute;
    top: -6px;
    right: -6px;
    z-index: 10;
`;

export const ThinkingBadge = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    height: 18px;
    padding: 0 6px;
    border-radius: 9px;
    background: ${p => p.theme.aiChat.card.background};
    border: 1.5px solid ${p => p.theme.aiChat.pill.expandedBorder};
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
`;

export const ThinkingDot = styled.span<{ $delay: number }>`
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: ${p => p.theme.aiChat.pill.leadingIcon};
    animation: ${dotPulse} 1.2s ease-in-out infinite;
    animation-delay: ${p => p.$delay}ms;
`;

export const UnreadBadge = styled.div`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${props => props.theme.fill.brand};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
`;
